/* eslint-disable import/first */
/* eslint-disable no-unused-vars */
import _extends from '@babel/runtime/helpers/extends'
import _objectSpread from '../objectSpread'
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties'
const _excluded = [
  'children',
  'altTheme',
  'thresholdX',
  'thresholdY',
  'showSnackbar',
  'onDismiss',
  'relative',
  'mode',
  'position',
  'className',
  'iconSize'
]

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IconButton from '@mui/material/IconButton'
import closeIcon from 'images/icon-close.png'
import styles from './Snackbar.module.sass'
import cx from 'classnames'

class Snackbar extends Component {
  constructor(...args) {
    super(...args)
    this.state = {
      delta: 0,
      deltaY: 0,
      showSnackbar: false,
      mouse: 0,
      mouseY: 0,
      offset: 0,
      isPressed: false,
      internalUpdate: false
    }
    this.dismissalTime = null

    this.handleMouseDown = ({ pageX, pageY }) => {
      this.setState({
        delta: pageX,
        deltaY: pageY,
        isPressed: true,
        internalUpdate: true
      })
    }

    this.handleTouchStart = evt => {
      this.handleMouseDown(evt.touches[0])
    }

    this.handleMouseMove = evt => {
      const { isPressed, delta, deltaY } = this.state // Don't drag iOS body with snackbar

      evt.preventDefault()

      if (isPressed) {
        let mouse = (evt.pageX || evt.touches[0].pageX) - delta

        if (Math.abs(mouse) >= this.props.thresholdX) {
          this.dismiss()
          return
        }

        let mouseY = (evt.pageY || evt.touches[0].pageY) - deltaY

        if (Math.abs(mouseY) >= this.props.thresholdY) {
          this.dismiss()
          return
        }

        if (Math.abs(mouse) > Math.abs(mouseY)) {
          mouseY = 0
        } else {
          mouse = 0
        }

        this.setState({
          mouse: mouse,
          mouseY: mouseY,
          isPressed: true,
          internalUpdate: true
        })
      }
    }

    this.handleMouseUp = () => {
      this.setState({
        isPressed: false,
        delta: 0,
        deltaY: 0,
        mouse: 0,
        mouseY: 0,
        internalUpdate: true
      })
    }

    this.dismiss = () => {
      this.setState({
        showSnackbar: false,
        internalUpdate: true
      })
      typeof this.props.onDismiss === 'function' && this.props.onDismiss()
    }

    this.storeSnackbarReference = snackbar => {
      if (snackbar !== null) {
        this.snackbar = snackbar
      }
    }
  }

  static getDerivedStateFromProps(
    { showSnackbar },
    { showSnackbar: stateShowSnackbar, internalUpdate }
  ) {
    if (internalUpdate) {
      // Prop should not prevent internal state changes
      return {
        internalUpdate: false
      }
    } else if (stateShowSnackbar !== showSnackbar) {
      return {
        showSnackbar,
        isPressed: false
      }
    }

    return null
  }

  componentDidMount() {
    const { dismissal, showSnackbar } = this.props

    if (dismissal) {
      this.dismissalTime = setTimeout(() => {
        this.dismiss()
      }, dismissal)
    }

    window.addEventListener('touchend', this.handleMouseUp)
    window.addEventListener('mouseup', this.handleMouseUp)
    this.setState({
      offset: Math.abs(this.snackbar.offsetHeight + 100) * -1,
      internalUpdate: true,
      // If `showSnackbar` prop is provided, we use it (`false` can be used to delay or prevent display)
      // Default behavior is to animate display on initial render
      showSnackbar: showSnackbar === undefined ? true : showSnackbar
    })
  }

  componentWillUnmount() {
    if (this.dismissalTime) {
      clearTimeout(this.dismissalTime)
    }

    window.removeEventListener('touchend', this.handleMouseUp)
    window.removeEventListener('mouseup', this.handleMouseUp)
  }

  render() {
    const _this$props = this.props,
      {
        children,
        altTheme,
        // thresholdX,
        // thresholdY,
        relative,
        mode,
        position,
        className,
        iconSize
      } = _this$props,
      other = _objectWithoutProperties(_this$props, _excluded)

    const themeStyles = _objectSpread(_objectSpread({}, styles), altTheme)

    const { mouse, mouseY, showSnackbar, isPressed, offset } = this.state
    // const threshold = mouseY === 0 ? thresholdX : thresholdY
    // const distance = mouseY === 0 ? mouse : mouseY
    const easing = 'cubic-bezier(0.645, 0.045, 0.355, 1.000)'
    let transitionStyle = `transform 250ms ${easing}, opacity 250ms ${easing}, visibility 1ms 250ms`

    if (isPressed) {
      transitionStyle = ''
    } else if (showSnackbar) {
      transitionStyle = `transform 250ms ${easing}, opacity 250ms ${easing}`
    }

    const transformStyle = `translate(${mouse}px, ${mouseY ||
      (showSnackbar ? 0 : offset)}px)`
    const animationStyle =
      position === 'floating'
        ? {
            transform: transformStyle,
            WebkitTransform: transformStyle,
            transition: transitionStyle,
            WebkitTransition: transitionStyle
          }
        : {
            transition: `opacity 250ms ${easing}, visibility 1ms 250ms`,
            WebkitTransition: `opacity 250ms ${easing}, visibility 1ms 250ms`
          }

    const style = _objectSpread(
      _objectSpread({}, animationStyle),
      {},
      {
        display: 'flex',
        alignItems: 'center',
        opacity: showSnackbar ? 1 : 0,
        visibility: !showSnackbar ? 'hidden' : 'visible'
      },
      relative && {
        position: 'relative'
      }
    )

    return /*#__PURE__*/ React.createElement(
      'div',
      _extends({}, other, {
        ref: this.storeSnackbarReference,
        onMouseDown: position === 'floating' ? this.handleMouseDown : undefined,
        onTouchStart:
          position === 'floating' ? this.handleTouchStart : undefined,
        onMouseMove: position === 'floating' ? this.handleMouseMove : undefined,
        onTouchMove: position === 'floating' ? this.handleMouseMove : undefined,
        style: style,
        unselectable: 'on',
        className: cx(
          themeStyles[mode],
          themeStyles[position],
          themeStyles.snackbar,
          className
        )
      }),
      React.createElement(
        IconButton,
        {
          className: themeStyles.button,
          colorTier: !mode ? 'knockout' : 'default',
          onClick: this.dismiss,
          onTouchEnd: this.dismiss,
          style: {
            position: 'absolute',
            color: '#fff',
            right: '24px',
            padding: '0',
            top: 'auto'
          }
        },
        React.createElement('img', {
          src: closeIcon,
          alt: 'close icon'
        })
      ),
      children
    )
  }
}

Snackbar.defaultProps = {
  thresholdX: 100,
  thresholdY: 50,
  relative: false,
  position: 'floating',
  iconSize: 19
}
Snackbar.displayName = 'Snackbar'
Snackbar.propTypes = {
  /**
   * The drag/swipe distance in X required to dismiss the snackbar
   */
  thresholdX: PropTypes.number,

  /**
   * The drag/swipe distance in Y required to dismiss the snackbar
   */
  thresholdY: PropTypes.number,

  /**
   * Is the snackbar visible?
   */
  showSnackbar: PropTypes.bool,

  /**
   * Callback when the snackbar is dismissed
   */
  onDismiss: PropTypes.func,

  /**
   * The component children
   */
  children: PropTypes.node,

  /**
   * A CSS modules style object to override default theme
   */
  altTheme: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

  /**
   * Is the snackbar positioned relative to its container ?
   */
  relative: PropTypes.bool,

  /**
   * Color mode
   */
  mode: PropTypes.oneOf(['', 'error']),
  /* For v3, change this to colorMode. Use `mode` in place of `position` prop
  /**
  * Time (in milliseconds) when the snackbar will be hidden
  */
  dismissal: PropTypes.number,

  /**
   * The position of the snackbar
   */
  position: PropTypes.oneOf(['top', 'floating', 'bottom']),

  /**
   * An additional custom className for the root element
   */
  className: PropTypes.string,

  /**
   * The icon size
   */
  iconSize: PropTypes.number
}
export default Snackbar
